'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NitroLogo = function NitroLogo(_ref) {
  var className = _ref.className,
      title = _ref.title,
      variant = _ref.variant;

  return _react2.default.createElement(_styles.Logo, { className: className, title: title, variant: variant });
};

NitroLogo.propTypes = {
  className: _propTypes2.default.string,
  title: _propTypes2.default.string,
  variant: _propTypes2.default.string
};

NitroLogo.defaultProps = {
  variant: 'default'
};

exports.default = NitroLogo;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-logo/NitroLogo.js
// module id = 3015
// module chunks = 4